import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import JaPage from "./pages/JaPage";
import EnPage from "./pages/EnPage";
import * as gtag from "./lib/gtag";

function App() {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtag.GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Define gtag after the script loads
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", gtag.GA_MEASUREMENT_ID);
    };
  }, []);

  useEffect(() => {
    // Track page view on route change
    if (typeof window.gtag === "function") {
      window.gtag("config", gtag.GA_MEASUREMENT_ID, {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<EnPage />} />
      <Route path="/ja" element={<JaPage />} />
    </Routes>
  );
}

export default App;
